import React from "react";
import loader from "../../Assets/images/loader.gif";
import { Spinner } from "reactstrap";

const Loading = ({ fullSize }) => {
  return <Spinner color="#FFFFFF" />;
};

export default Loading;
